<template>
  <modal size="xl" @close="$emit('close')">
    <template #head>
      <div class="modal-header">
        <h4 class="modal-title">Convert Save</h4>
        <div class="flex">
          <button
            class="btn btn-info btn-xs waves-effect waves-light m-l-5"
            type="button"
            @click="$root.clipboardCopy(JSON.stringify(data, null, 2))"
          >
            <span>Copy</span>
          </button>
          <button class="close" type="button" @click="$emit('close')">×</button>
        </div>
      </div>
    </template>
    <template #content>
      <loadArea v-if="data == null"></loadArea>
      <template v-if="data != null">
        <pre class="m-0">{{ data }}</pre>
      </template>
    </template>
  </modal>
</template>

<script>
import axios from "axios";
export default {
  name: "convertSave",
  props: {
    id: String,
    isSubjectVoucher:Boolean
  },
  data() {
    return {
      data: null,
    };
  },
  created() {
    axios
      .get(`https://api.kolayrez.com/mailworker/ConvertSave/` + this.id+(this.isSubjectVoucher?'?convertwithsubjectvoucher=true':''))
      .then((response) => {
        console.log("response", response);
        this.data = response.data;
        if (response.status == 200 && response.data.IsSuccess == undefined) {
          this.$emit("readSuccess", this.id);
        }
      })
      .catch((err) => {
        this.$isError(err);
        this.$emit("close");
      });
  },
  methods: {
    setResponse(data) {
      try {
        return JSON.parse(data);
      } catch (error) {
        return data;
      }
    },
  },
};
</script>

<style scoped>
pre {
  box-shadow: none;
}
ul li {
  padding: 5px 10px;
  font-size: 14px;
  word-wrap: break-word;
}
ul li:nth-child(even) {
  background: #f6f6f6;
}
.attachments {
  margin: 0;
  padding: 8px;
}
.attachments > div {
  padding: 2px;
}
.attachments > div a {
  margin: 0 !important;
  display: block;
}
</style>
